import { render, staticRenderFns } from "./CoozzyAssigneeMultiselect.vue?vue&type=template&id=466b99fc&scoped=true"
import script from "./CoozzyAssigneeMultiselect.vue?vue&type=script&lang=js"
export * from "./CoozzyAssigneeMultiselect.vue?vue&type=script&lang=js"
import style0 from "./CoozzyAssigneeMultiselect.vue?vue&type=style&index=0&id=466b99fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "466b99fc",
  null
  
)

export default component.exports